import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getLegacyRecepcionesVehiculos } from '../../helpers/api_helper';

const recepcionesVehiculosHooks = (fechaInicio, fechaTermino, refresh = 0) => {
    const [recepciones, setRecepciones] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId)
    const empresa = useSelector((state) => state.Context.empresa)
    const departamento = useSelector((state) => state.Context.departamento)
    const userInfo = useSelector((state) => state.UserInfo.userInfo)

    useEffect(() => {
        const fetchRecepciones = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await getLegacyRecepcionesVehiculos({ tenantId, empresa, departamento, fechaInicio, fechaTermino, usuario: userInfo?.name });
                if (Array.isArray(response)) {
                    setRecepciones(response);
                } else {
                    throw new Error('API returned invalid data format: expected an array');
                }
            } catch (err) {
                setError(`Failed to fetch recepciones: ${err.message || 'Unknown error'}`);
                setRecepciones([]);
            } finally {
                setLoading(false);
            }
        };

        if (tenantId && empresa && departamento && fechaInicio && fechaTermino) {
            fetchRecepciones();
        }
    }, [tenantId, empresa, departamento, fechaInicio, fechaTermino, refresh]);

    return { recepciones, loading, error };
};

export default recepcionesVehiculosHooks;